import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Promotions from "./Promotions";
import PopularPlans from "./PopularPlans";
import Services from "./Services";
import Benefits from "./Benefits";
import HeroImage from "./HeroImage";
import { Element } from "react-scroll";
import Recharge from "./Recharge";

const Home = () => {
  const location = useLocation();
  const [isInitialVisit, setIsInitialVisit] = useState(true);

  useEffect(() => {
    const section = window.location.href.split("#")[1];
    if (section) {
      const element = document.getElementById(section);
      if (element) {
        if (isInitialVisit) {
          setTimeout(() => {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 400);
          setIsInitialVisit(false);
        } else {
          scrollToSection(element); // Scroll to the section if it exists
        }
      }
    }
     // eslint-disable-next-line
  }, [location]);

  const scrollToSection = (element) => {
    const yCoordinate = element.getBoundingClientRect().top + window.scrollY;
    const yOffset = -120;
    setTimeout(() => {
      window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
    }, 100);
  };

  return (
    <div>
      <Element name="hero-image" id="hero-image">
        <HeroImage />
      </Element>
      <Element name="recharge" id="recharge">
        <Recharge />
      </Element>
      <Element name="promotions" id="promotions">
        <Promotions />
      </Element>
      <Element name="popular-plans" id="popular-plans">
        <PopularPlans />
      </Element>
      <Element name="services" id="services">
        <Services />
      </Element>
      <Element name="benefits" id="benefits">
        <Benefits />
      </Element>
    </div>
  );
};

export default Home;
